export default class ProductionBuild {
	static detect() {
		return process.env.NODE_ENV === 'production';
	}
}
